import script from "./PersonalDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalDetails.vue?vue&type=script&setup=true&lang=js"

import "./PersonalDetails.vue?vue&type=style&index=0&id=88ec80b6&lang=css"

const __exports__ = script;

export default __exports__